import { createActions, handleActions } from 'redux-actions'

const defaultState = {
  selectedCourseIds: [],
  selectedSectionIds: [],
  // StudentIds and UserUuids should generally be set at the same time.
  // Ie, the UserUuids list reflects the UUIDs of the selected students, but
  // relies on associated containers to keep both lists updated at once.
  selectedStudentIds: [],
  selectedUserUuids: [],
  selectedStartingDate: '',
  selectedEndingDate: '',
  selectedContentTypes: [],
  committedCourseIds: [],
  committedSectionIds: [],
  committedStudentIds: [],
  committedUserUuids: [],
  committedStartingDate: '',
  committedEndingDate: '',
  committedContentTypes: []
}

// Action definitions
const {
  selectCourseIds,
  selectSectionIds,
  selectStudentIds,
  selectUserUuids,
  selectStartingDate,
  selectEndingDate,
  selectContentTypes,
  commitFilters,
  revertFilters
} = createActions({
  SELECT_COURSE_IDS:            ids => ({ ids }),
  SELECT_SECTION_IDS:           ids => ({ ids }),
  SELECT_STUDENT_IDS:           ids => ({ ids }),
  SELECT_USER_UUIDS:            uuids => ({ uuids }),
  SELECT_STARTING_DATE:         date => ({ date }),
  SELECT_ENDING_DATE:           date => ({ date }),
  SELECT_CONTENT_TYPES:         contentTypes => ({ contentTypes }),
  COMMIT_FILTERS:               undefined,
  REVERT_FILTERS:               undefined
})

// Reducer definition
const reducer = handleActions(
  {
    [selectCourseIds]: (state, { payload: { ids }}) => ({ ...state, selectedCourseIds: ids }),
    [selectSectionIds]: (state, { payload: { ids }}) => ({ ...state, selectedSectionIds: ids }),
    [selectStudentIds]: (state, { payload: { ids }}) => ({ ...state, selectedStudentIds: ids }),
    [selectUserUuids]: (state, { payload: { uuids }}) => ({ ...state, selectedUserUuids: uuids }),
    [selectStartingDate]: (state, { payload: { date }}) => ({ ...state, selectedStartingDate: date }),
    [selectEndingDate]: (state, { payload: { date }}) => ({ ...state, selectedEndingDate: date }),
    [selectContentTypes]: (state, { payload: {contentTypes }}) => ({ ...state, selectedContentTypes: contentTypes }),
    [commitFilters]: state => ({
        ...state,
        committedCourseIds:     state.selectedCourseIds,
        committedSectionIds:    state.selectedSectionIds,
        committedStudentIds:    state.selectedStudentIds,
        committedUserUuids:     state.selectedUserUuids,
        committedStartingDate:  state.selectedStartingDate,
        committedEndingDate:    state.selectedEndingDate,
        committedContentTypes:  state.selectedContentTypes
      }),
    [revertFilters]: state => ({
        ...state,
        selectedCourseIds:      state.committedCourseIds,
        selectedSectionIds:     state.committedSectionIds,
        selectedStudentIds:     state.committedStudentIds,
        selectedUserUuids:      state.committedUserUuids,
        selectedStartingDate:   state.committedStartingDate,
        selectedEndingDate:     state.committedEndingDate,
        selectedContentTypes:   state.committedContentTypes
      })
  },
  defaultState
)

export {
  defaultState,
  selectCourseIds,
  selectSectionIds,
  selectUserUuids,
  selectStudentIds,
  selectStartingDate,
  selectEndingDate,
  selectContentTypes,
  commitFilters,
  revertFilters
}
export default reducer
